"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TabPane = void 0;
var _react = _interopRequireDefault(require("react"));
var _classnames = _interopRequireDefault(require("classnames"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
var TabPane = function TabPane(_ref) {
  var children = _ref.children,
    hidden = _ref.hidden,
    className = _ref.className;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames.default)(hidden && 'hidden', className)
  }, children);
};
exports.TabPane = TabPane;